import { FC, ReactNode, MouseEvent } from "react";
import classNames from "classnames";
import styles from "./button.module.scss";

type Props = {
  type?: "submit" | "reset" | "button";
  children: ReactNode;
  onClick?: (e?: MouseEvent) => void;
  disabled?: boolean;
  color?: string;
  isProcessing?: boolean;
  isDisabled?: boolean;
};

export const Button: FC<Props> = ({
  type = "button",
  children,
  color,
  onClick,
  isProcessing = false,
  isDisabled = false,
}) => {
  return (
    <div
      className={classNames(styles.box, {
        [styles.processing]: isProcessing,
        [styles.disabled]: isDisabled,
      })}
    >
      <button
        type={type}
        onClick={onClick}
        className={styles.button}
        style={{ color: color }}
        disabled={isDisabled}
      >
        {children}
      </button>
    </div>
  );
};
